module.exports = (__parcel__import__("erwTu")).then(() => parcelRequire('fyWP3'));